"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTokenForColor = exports.chipCustomCssProperties = exports.SEMANTIC_CHIP_COLORS = void 0;
let SEMANTIC_CHIP_COLORS = /*#__PURE__*/function (SEMANTIC_CHIP_COLORS) {
  SEMANTIC_CHIP_COLORS["not-started"] = "neutral";
  SEMANTIC_CHIP_COLORS["in-progress"] = "blue";
  SEMANTIC_CHIP_COLORS["completed"] = "green";
  SEMANTIC_CHIP_COLORS["at-risk"] = "yellow";
  SEMANTIC_CHIP_COLORS["blocked"] = "red";
  return SEMANTIC_CHIP_COLORS;
}({});
exports.SEMANTIC_CHIP_COLORS = SEMANTIC_CHIP_COLORS;
const chipCustomCssProperties = {
  text: `--smar--core--chip--text`,
  backgroundRest: `--smar--core--chip--background--rest`,
  backgroundHover: `--smar--core--chip--background--hover`,
  backgroundActive: `--smar--core--chip--background--active`,
  removeButtonOpacity: `--smar--core--chip--remove--button--opacity`
};
exports.chipCustomCssProperties = chipCustomCssProperties;
const getTokenForColor = (color, themeMode) => {
  switch (themeMode) {
    case "lodestar-light":
      return getTokenForColorLodestar(color);
    default:
      return getTokenForColorDefault(color);
  }
};
exports.getTokenForColor = getTokenForColor;
const getTokenForColorDefault = color => {
  return {
    text: `color--text--spectrum-${color}--default`,
    backgroundRest: `color--background--spectrum-${color}--weakest`,
    backgroundHover: `color--background--spectrum-${color}--weaker`,
    backgroundActive: `color--background--spectrum-${color}--weak`
  };
};

/**
 * Kinda lame that we need to do this, but Lodestar's Tag and Token components have a much darker
 * theme we want to support since we're upgrading people directly from the Tag/Token to Chip.
 */
const getTokenForColorLodestar = color => {
  return {
    text: `color--text--spectrum-${color}--strong`,
    backgroundRest: `color--background--spectrum-${color}--weak`,
    backgroundHover: `color--background--spectrum-${color}--default`,
    backgroundActive: `color--background--spectrum-${color}--strong`
  };
};
//# sourceMappingURL=chipConstants.js.map